import { deleteKeysFromObjects } from "./dataManipulation";

type Data = DataRow[];

type DataRow = {
  [key: string]: any;
};

type DataUtilities = string[];

type SelectedValues = string[];

export const dataMultiSelectFilterFunctionByUtilities = (
  dataUtilities?: DataUtilities | undefined,
  data?: Data | undefined,
  dataKey?: string,
  selectedValues?: SelectedValues | undefined
) => {
  if (!selectedValues?.length) return data;
  const columnsToRemove = dataUtilities?.filter((col) => !selectedValues?.includes(col));
  return deleteKeysFromObjects(data, columnsToRemove);
};
